import { render } from "./Produk.vue?vue&type=template&id=82076886"
import script from "./Produk.vue?vue&type=script&lang=js"
export * from "./Produk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__